import ApiService from '@/services/core/api.service'

const ReportService = {
  async getApprovalHistories (query) {
    return ApiService.get(`tax-accountant/reports/approval-histories?${query}`)
  }
}

export default ReportService
